import { render } from "./Tick.vue?vue&type=template&id=aa0b582c&scoped=true"
import script from "./Tick.vue?vue&type=script&lang=js"
export * from "./Tick.vue?vue&type=script&lang=js"

import "./Tick.vue?vue&type=style&index=0&id=aa0b582c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa0b582c"]])

export default __exports__